import { render } from "./opEditable.vue?vue&type=template&id=1f2ac524&scoped=true&ts=true"
import script from "./opEditable.vue?vue&type=script&lang=ts"
export * from "./opEditable.vue?vue&type=script&lang=ts"

import "./opEditable.vue?vue&type=style&index=0&id=1f2ac524&scoped=true&lang=css"

import exportComponent from "C:\\projects\\totalrender\\onofficeapp\\marketplaceapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f2ac524"]])

export default __exports__